<template>
    
</template>

<script>
document.addEventListener('turbo:load', () => {
})
export default {
    data(){
        return {
          menuCheckbox: false,
        }
    },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    'menuCheckbox': function(newVal) {
      const vueApp = this.$root && this.$root.$el;
      if (!vueApp) return;

      if (newVal) {
          vueApp.classList.add('no-scroll');
      } else {
          vueApp.classList.remove('no-scroll');
      }
    }
  },
  methods: {
    redirectTo(path) {
      window.location.href = path
    },
    handleResize() {
      if (window.innerWidth >= 1200) {
        this.menuCheckbox = false;
      }
    },
  }
}
</script>
